import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Ultrahuman × Luminary acquisition flow for the Ring PRO buy page
// (`/ring-pro/buy?flow=luminary`). US-only, so this is a Partial map rather
// than the full Record every other addon uses.
//
// The offer is 19% off the Ring PRO line + 6 months of Cycle & Ovulation Pro
// included free. Because CNO Pro is bundled, the CNO Pro selector is hidden in
// this flow (see ProductSelectionSection).
//
// The Shopify code is not in this file. The client pushes
// LUMINARY_RING_DISCOUNT_SENTINEL and the cart API replaces it in
// content/products/addons/luminaryDiscount.server.ts.
// Annotated `boolean` on purpose: without it TS narrows to the literal `false`
// and collapses every branch that depends on it.
export const LUMINARY_FLOW_ENABLED: boolean = true;

/** Placeholder the browser sends. The cart API swaps in the Shopify code. */
export const LUMINARY_RING_DISCOUNT_SENTINEL = 'luminary-ring-pro';

export type LuminaryFlowConfig = {
  ringDiscountPercentage: number;
  cnoPro: {
    months: number;
    variantId: string;
  };
};

export const LuminaryFlowShopifyMap: Partial<
  Record<ShopifyStore, LuminaryFlowConfig>
> = {
  [ShopifyStore.US]: {
    ringDiscountPercentage: 19,
    cnoPro: {
      months: 6,
      variantId: 'gid://shopify/ProductVariant/42985702555744',
    },
  },
};
